<div class="form-preview">
    @if (isLoading()) {
    <div class="loading-overlay center-loader">
        <p-progressSpinner [style]="{height: '50px', width: '50px'}" strokeWidth="4"
            animationDuration="0.5s"></p-progressSpinner>
    </div>
    }

    @if (submittedSuccessfully()) {
    <div class="submittedMessage-overlay">
        <div class="successContainer">
            <div class="icon">
                <img src="./assets/icons-svg/check.svg" />
            </div>
            <div class="content">
                <div class="title">{{ editMode() ? 'Registration details updated successfully' : 'Your application has
                    been submitted successfully' }}</div>
                <div class="subtitle">{{ editMode() ? 'The candidate details have been updated.' : 'Kindly check your
                    email for further notifications.' }}</div>
            </div>
        </div>
    </div>
    }

    @if (alreadyRegistered()) {
    <div class="submittedMessage-overlay">
        <div class="successContainer">
            <div class="icon">
                <img src="./assets/icons-svg/check.svg" />
            </div>
            <div class="content">
                <div class="title">Candidate already registered for this event</div>
                <div class="subtitle">Kindly check your email for further notifications.</div>
            </div>
        </div>
    </div>
    }

    @if (offerFormSuccess()) {
    <div class="submittedMessage-page">
        <div class="successContainer">
            <div class="icon">
                <img src="./assets/icons-svg/check.svg" />
            </div>
            <div class="content">
                <div class="title">Success</div>
                <div class="subtitle">Thank you for submitting the response.</div>
            </div>
        </div>
    </div>
    }

    @if (offerFormWarning()) {
    <div class="submittedMessage-page">
        <div class="successContainer">
            <div class="warning-icon">
                <img src="./assets/icons-svg/Warning.svg" />
            </div>
            <div class="content">
                <div class="title">NOTE!</div>
                <div class="subtitle">{{documentationErrorMsg()}}</div>
            </div>
        </div>
    </div>
    }

    @if (formExpired()) {
    <div class="submittedMessage-overlay">
        <div class="successContainer">
            <div class="warning-icon">
                <img src="./assets/icons-svg/Warning.svg" />
            </div>
            <div class="content">
                <div class="title">NOTE!</div>
                <div class="subtitle">Registration no longer accepted.</div>
            </div>
        </div>
    </div>
    }

    @if(documentationError()) {
    <div class="submittedMessage-overlay">
        <div class="successContainer">
            <div class="warning-icon">
                <img src="./assets/icons-svg/Warning.svg" />
            </div>
            <div class="content">
                <div class="title">NOTE!</div>
                <div class="subtitle">{{documentationErrorMsg()}}</div>
            </div>
        </div>
    </div>
    }

    @if(registrationNotStarted()) {
    <div class="submittedMessage-overlay">
        <div class="successContainer">
            <div class="warning-icon">
                <img src="./assets/icons-svg/Warning.svg" />
            </div>
            <div class="content">
                <div class="title">NOTE!</div>
                <div class="subtitle">Registration has not started yet.</div>
            </div>
        </div>
    </div>
    }

    @if(invalidUrl()) {
    <div class="submittedMessage-page">
        <div class="successContainer">
            <div class="warning-icon">
                <img src="./assets/icons-svg/Warning.svg" />
            </div>
            <div class="content">
                <div class="title">Invalid Event</div>
                <div class="subtitle">The selected event is invalid.</div>
            </div>
        </div>
    </div>
    }

    @if (stateEmpty()) {
    <div class="form-preview__error-state">
        <div class="form-preview__error-content">
            <div class="form-preview__error-icon">
                <i class="pi pi-info-circle"></i>
            </div>
            <h2 class="form-preview__title">No Form to Preview</h2>
            <div class="form-preview__empty-message">
                <p>There is no form data available for preview.</p>
                <p>Please make sure you have:</p>
                <ul>
                    <li>Added sections to your form</li>
                    <li>Added fields to the sections</li>
                    <li>Specified form name and other required information</li>
                </ul>
            </div>
            <div class="form-preview__actions">
                <button pButton label="Back to Form Builder" class="p-button-primary" (click)="backToEdit()"></button>
            </div>
        </div>
    </div>
    }

    @if(errorType()) {
    <div class="form-preview__error-state">
        <div class="form-preview__error-content">
            <div class="form-preview__error-icon">
                <i class="pi pi-info-circle"></i>
            </div>
            <h2 class="form-preview__title">
                @switch (errorType()) {
                @case ('not-found') {
                Form Not Found
                }
                @case ('server-error') {
                Server Error
                }
                @case ('invalid-uuid') {
                Invalid Form ID
                }
                }
            </h2>
            <div class="form-preview__empty-message">{{ errorMessage() }}</div>
            <div class="form-preview__actions">
                <button pButton label="Back to Forms List" class="p-button-primary" (click)="backToForms()"></button>
            </div>
        </div>
    </div>
    }

    @if(!isLoading() && !stateEmpty() && !errorType() && !alreadyRegistered() && formData && (!otpRequired() ||
    otpVerified() || emailVerified())) {
    <div class="form">
        @if (((formType() !== 'registration') && headerContent())) {
        <!-- Header -->
        <div class="header" [style.background]="formData.bg_colour | gradientCss">
            <p>{{headerContent()}}</p>
        </div>
        }

        @if (formType() === 'registration' && !editMode()) {
        <div class="registration-header" style="position: relative;"
            [style.background]="formData.bg_colour | gradientCss">
            <ng-template *ngTemplateOutlet="logo"></ng-template>

            @if(eventDetails()?.job_roles?.length === 1 && eventDetails()?.job_roles[0] && showJobRoles() &&
            !editMode()) {
            <div class="job-role-header registration-job-header" style="cursor: unset;">
                <ng-container *ngTemplateOutlet="jobRoleHeader; context: { $implicit: eventDetails()?.job_roles[0] }">
                </ng-container>
            </div>
            }

            @if(!showJobRoles() || previewMode) {
            <p class="registration-header-content" [class.pb]="previewMode">{{headerContent()}}</p>
            }

            @if (!previewMode && !editMode()) {
            <div class="registration-header-tabs">
                <div class="registration-header-tab" [class.active]="showJobRoles()"
                    (click)="toggleJobDetailsAndForm(true)">
                    Job Details
                </div>
                <div class="registration-header-tab" [class.active]="!showJobRoles()"
                    (click)="toggleJobDetailsAndForm(false)">
                    Application Form
                </div>
            </div>
            }
        </div>
        }

        @if (showJobRoles() && !previewMode && formType() === 'registration' && !editMode()) {
        <div class="form-content">
            @if (!loadingJobDetails()) {
            @for (jobRole of eventDetails()?.job_roles; track $index) {
            @if (jobRole) {
            <div class="registration-job-role">
                @if (eventDetails()?.job_roles?.length > 1) {
                <div class="job-role-header" [class.opened]="jobRole.isOpened" (click)="toggleActiveJobRole(jobRole)">
                    <ng-container *ngTemplateOutlet="jobRoleHeader; context: { $implicit: jobRole }">
                    </ng-container>

                    <div class="job-role-header-actions">
                        @if (eventDetails()?.job_roles?.length > 1) {
                        @if (jobRole.isOpened) {
                        <i class="pi pi-chevron-up"></i>
                        } @else {
                        <i class="pi pi-chevron-down"></i>
                        }
                        }
                    </div>
                </div>
                }

                @if (jobRole.isOpened) {
                <div class="job-role-details">
                    <div class="job-role-detail">
                        <p class="job-role-detail-title">Description</p>
                        <div class="job-role-detail-content">
                            <app-innerhtml-view
                                [preview]="jobRole.description ? (jobRole.description | getSafeHTMLEmail) : 'No description available'">
                            </app-innerhtml-view>
                        </div>
                    </div>

                    @if (jobRole?.preferred_location?.length) {
                        <div class="job-role-detail">
                            <p class="job-role-detail-title">{{jobRole?.preferred_location?.length > 1 ? "Locations" : "Location"}}</p>
                            <div class="job-role-detail-content">
                                {{jobRole?.preferred_location?.join(", ")}}
                            </div>
                        </div>
                    }

                    <button style="width: fit-content; align-self: center;" (click)="selectTheRole(jobRole)" pButton
                        class="neo-btn outline" label="Apply for this position"></button>
                </div>
                }
            </div>
            }
            } @empty {
            <empty-state>
                <empty-state-icon>
                    <img src="assets/icons-svg/NoDocuments.svg" />
                </empty-state-icon>
                <empty-state-title>No Jobs Found</empty-state-title>
                <empty-state-subtitle>
                    No associated jobs found for the drive.
                </empty-state-subtitle>
            </empty-state>
            }
            } @else {
            <p-progressSpinner ariaLabel="loading" [style]="{'height': '40px'}" />
            }
        </div>
        }

        <!-- Scroll Area START -->
        <div class="form-content"
            [class.hidden]="showJobRoles() && !previewMode && formType() === 'registration' && !editMode()">
            @if (formType() !== 'registration') {
            <ng-template *ngTemplateOutlet="coverAndLogo"></ng-template>
            }

            @if(formType() === 'registration') {
            <ng-template *ngTemplateOutlet="cover"></ng-template>
            }

            <!-- Title -->
            @if (formType() === 'documentation') {
            <div class="form-data">
                <h2 class="form-title">Additional Questionnaire and Documents Submission Form</h2>
            </div>
            }
            @if (formType() !== 'documentation' && (formType() !== "registration" && !previewMode)) {
            <div class="form-data">
                <h2 class="form-title">{{formType() | titlecase}} Form</h2>
            </div>
            }

            <!-- Note -->
            @if(previewMode) {
            <div class="warning-msg">
                <strong>Note:</strong> This is a preview. Fields are in read-only mode.
            </div>
            }

            @if (formName() === "Extended Details and Documentation Form" && !previewMode) {
            <div class="warning-msg">
                <strong>Note:</strong> Documents cannot be modified after submission. Please ensure all information is
                accurate.
            </div>
            }

            @if(this.formType() === 'registration' && !previewMode && !emailVerified() && !editMode()) {
            <div class="warning-msg">
                <strong>Note:</strong> Please verify your email to continue with the registration.
            </div>
            }

            <!-- Content -->
            <div class="form-sections">
                @for (section of templateCollections(); track $index) {
                <div class="form-section" *ngIf="canShowSection(section)">
                    <div class="section-title">
                        {{section[0].displaySection}}
                    </div>
                    <div class="section-contents">
                        @for (field of section; track $index) {
                        <div class="section-content" [attr.element_type]="field.element_type" *ngIf="field.visible"
                            [attr.full-grid-col]="field.fieldType === 'file' || field.fieldType === 'multi-file' || field.fieldType === 'checkbox' || field.fieldType === 'radio'">
                            <app-fields-v2 [model]="field" [preview]="previewMode" [duplicateData]="duplicateData"
                                (checkValidator)="checkValid($event, field)"
                                (fieldDataEmitter)="bindData($event, field)"
                                (collegeNameDataEmitter)="bindDataCollegeName($event, field)"
                                (enableEmailVerification)="enableEmailVerification($event)"
                                [verifyingEmail]="verifyingEmail" [emailVerified]="emailVerified()"
                                [markAsTouced]="markAsTouced" [removeFiles$]="removeFiles$" [eventId]="eventId()"
                                [editMode]="editMode()" [photoCaptureMode]="photoCaptureMode"></app-fields-v2>
                        </div>
                        @if (needToShowOtherCollegeDetails(field.fieldValue, field.answer)) {
                        <div class="section-content" [attr.element_type]="field.element_type"
                            [attr.full-grid-col]="field.fieldType === 'file' || field.fieldType === 'multi-file' || field.fieldType === 'checkbox' || field.fieldType === 'radio'">
                            <div class="additional-fields">
                                <p class="field-name">
                                    Specify {{field.fieldName}}
                                    <span class="imp">*</span>
                                </p>
                                <span [class]="field.fieldType">
                                    <input pInputText [id]="field.fieldId + 'college name'"
                                        [placeholder]="field.placeHolder" [type]="'text'"
                                        [class.disable-input-field]="field.disabled ?? false"
                                        [value]="getOtherCollegeValue(field.fieldValue, 'college_name')"
                                        (change)="changeOtherCollegeValue($event, field.fieldValue, 'college_name', field)"
                                        [readOnly]="field.readOnly || previewMode"
                                        [disabled]="field.disabled || !emailVerified" [required]="field.isMandatory"
                                        (ngModelChange)="otherCollegeDetails(field, 'college_name')"
                                        [class.is-invalid]="!field.disabled && !field.isValid && !previewMode" />
                                    @if (!field.disabled && !field.isValid && !previewMode &&
                                    !isValidOtherCollegeName(field.isMandatory,
                                    field.fieldValue) && getOtherCollegeValue(field.fieldValue, 'college_name').length)
                                    {
                                    <span class="error-message">Please enter valid data. Only alphabets and spaces are
                                        allowed.</span>
                                    }
                                </span>
                            </div>
                        </div>
                        <div class="section-content" [attr.element_type]="field.element_type"
                            [attr.full-grid-col]="field.fieldType === 'file' || field.fieldType === 'multi-file' || field.fieldType === 'checkbox' || field.fieldType === 'radio'">
                            <div class="additional-fields">
                                <p class="field-name">
                                    Specify {{field.fieldName.replace("name", "")}} city
                                    <span class="imp">*</span>
                                </p>

                                <span [class]="field.fieldType">
                                    <input pInputText [id]="field.fieldId + 'college city'"
                                        [placeholder]="field.placeHolder" [type]="'text'"
                                        [class.disable-input-field]="field.disabled ?? false"
                                        [value]="getOtherCollegeValue(field.fieldValue, 'college_city')"
                                        (change)="changeOtherCollegeValue($event, field.fieldValue, 'college_city', field)"
                                        [readOnly]="field.readOnly || previewMode"
                                        [disabled]="field.disabled || !emailVerified" [required]="field.isMandatory"
                                        (ngModelChange)="otherCollegeDetails(field, 'college_city')"
                                        [class.is-invalid]="!field.disabled && !field.isValid && !previewMode" />
                                    @if (!field.disabled && !field.isValid && !previewMode &&
                                    !isValidOtherCollegeCity(field.isMandatory,
                                    field.fieldValue) && getOtherCollegeValue(field.fieldValue, 'college_city').length)
                                    {
                                    <span class="error-message">Please enter valid data. . Only alphabets and spaces are
                                        allowed.</span>
                                    }
                                </span>
                            </div>
                        </div>
                        <div class="section-content" [attr.element_type]="field.element_type"
                            [attr.full-grid-col]="field.fieldType === 'file' || field.fieldType === 'multi-file' || field.fieldType === 'checkbox' || field.fieldType === 'radio'">
                            <div class="additional-fields">
                                <p class="field-name">
                                    Specify {{field.fieldName.replace("name", "")}} state
                                    <span class="imp">*</span>
                                </p>

                                <span [class]="field.fieldType">
                                    <input pInputText [id]="field.fieldId + 'college state'"
                                        [placeholder]="field.placeHolder" [type]="'text'"
                                        [class.disable-input-field]="field.disabled ?? false"
                                        [value]="getOtherCollegeValue(field.fieldValue, 'college_state')"
                                        (change)="changeOtherCollegeValue($event, field.fieldValue, 'college_state', field)"
                                        [readOnly]="field.readOnly || previewMode"
                                        [disabled]="field.disabled || !emailVerified" [required]="field.isMandatory"
                                        (ngModelChange)="otherCollegeDetails(field, 'college_state')"
                                        [class.is-invalid]="!field.disabled && !field.isValid && !previewMode" />
                                    @if (!field.disabled && !field.isValid && !previewMode &&
                                    !isValidOtherCollegeState(field.isMandatory,
                                    field.fieldValue) && getOtherCollegeValue(field.fieldValue, 'college_state').length)
                                    {
                                    <span class="error-message">Please enter valid data. . Only alphabets and spaces are
                                        allowed.</span>
                                    }
                                </span>
                            </div>
                        </div>
                        }
                        @if (needToShowOtherValue(field.fieldValue, field.answer)) {
                        <div class="section-content" [attr.element_type]="field.element_type">
                            <div class="additional-fields">
                                <p class="field-name">
                                    Specify {{field.fieldName}}
                                    <span class="imp">*</span>
                                </p>
                                <span [class]="field.fieldType">
                                    <input pInputText [id]="field.fieldId + 'other value'"
                                        [placeholder]="field.placeHolder" [type]="'text'"
                                        [class.disable-input-field]="field.disabled ?? false"
                                        [value]="getOtherValue(field.fieldValue)"
                                        (change)="changeOtherValue($event, field)"
                                        [readOnly]="field.readOnly || previewMode"
                                        [disabled]="field.disabled || !emailVerified" [required]="field.isMandatory"
                                        [class.is-invalid]="!field.disabled && !field.isValid && !previewMode" />
                                    @if (!field.disabled && !field.isValid && !previewMode &&
                                    !isValidOtherValue(field.fieldValue) && getOtherValue(field.fieldValue).length) {
                                    <span class="error-message">Please enter valid data. Only alphabets, numbers, spaces
                                        and &amp; . , - / ( ) are allowed.</span>
                                    }
                                </span>
                            </div>
                        </div>
                        }
                        }
                    </div>
                </div>
                }
            </div>

            <!-- Submit Button -->
            <div style="display: flex; justify-content: center;">
                <button pButton pRipple type="button" [label]="editMode() ? 'Update' : 'Submit'" class="form-btn"
                    (click)="submittingForm() ? null : verifyOnSubmit()"
                    [disabled]="!emailVerified() || previewMode || submittingForm() || (editMode() && (!formDirty() || !duplicateData.emailDuplicate))"
                    [loading]="submittingForm()"></button>
            </div>
        </div>
        <!-- Scroll Area END -->


        <!-- Footer -->
        @if(footerContent() && !editMode()) {
        <div class="header"
            [class.hidden]="(showJobRoles() && !previewMode && formType() === 'registration' && !editMode())"
            [style.background]="formData.bg_colour | gradientCss">
            <p>{{footerContent()}}</p>
        </div>
        }

    </div>
    }
</div>

@if (otpRequired() && !otpVerified() && !emailVerified()) {
<div>
    <app-otp-verification (otpVerified)="otpVerified.set($event); prefillForm()" [emailToVerify]="emailToVerify()"
        (emailVerified)="emailVerified.set(true);" [eventId]="eventId()" [formType]="formType()"
        (previousFormDetails)="previousFormDetails.set($event)"></app-otp-verification>
</div>
}

<div class="reg-dialog">
    <p-dialog styleClass="otp-dialog" header="OTP Verification" [visible]="otpSent()" (visibleChange)="otpSent.set(!otpSent())"
        [modal]="true" [draggable]="false" [resizable]="false" (onHide)="dialogClose()">
        <div class="otpContainer">
            <p class="otp-content" style="margin-top: 2rem; margin-bottom: 1.3rem;">We have sent the 6 digit
                verification code to {{verifyChoice() == 'email' ? '' : 'the mobile number'}}
                <span style="color: blue; display: block;">
                    {{verifyChoice() == 'email' ? (emailToVerify() ? emailToVerify() :'') : ''}}
                </span>
            </p>
            <div class="otp-boxes" (paste)="onOtpPaste($event)">
                <input *ngFor="let digit of otpInputs; let i = index" type="text" maxlength="1"
                    [(ngModel)]="otpDigits[i]" (input)="onOtpInput($event, i)" (keydown)="onOtpKeyDown($event, i)"
                    class="otp-input" #otpInput />
            </div>
            <div class="button-container" style="display: flex; flex-direction: column;">
                <div class="resend-info"
                    style="display: flex; justify-content: end;margin-top: 10px;margin-bottom: 25px;">
                    <span *ngIf="otpTimer() > 0" class="resent-timer">Resend in
                        <strong>{{otpCountdown()}}s</strong></span>
                    <span *ngIf="otpTimer() <= 0" (click)="resendEmailOtp()" class="resend-btn">
                        <span *ngIf="!loadResend">Resend</span>
                        <p-progressSpinner *ngIf="loadResend"
                            [style]="{height: '20px', width: '20px', marginRight: '30px'}" strokeWidth="7"
                            animationDuration="0.5s">
                        </p-progressSpinner>
                    </span>
                </div>
                <div class="card flex justify-content-center submit-btn mt-45" style="width: 100%;">
                    <button pButton class="neo-btn" label="Verify" [disabled]="!enableVerify() || verifyingOTP()" [loading]="verifyingOTP()"
                        [ngStyle]="{'pointer-events': (enableVerify() ? 'auto' : 'none'), 'width': '100%' }"
                        (click)="verifyingOTP() ? null : verifyEmailOtp()"></button>
                </div>
            </div>
        </div>
    </p-dialog>
</div>

<ng-template #coverAndLogo>
    <ng-template *ngTemplateOutlet="cover"></ng-template>
    <ng-template *ngTemplateOutlet="logo"></ng-template>
</ng-template>

<ng-template #logo>
    <div class="logo">
        <img class="logo-img" [src]="formLogo()" alt="Logo">
    </div>
</ng-template>

<ng-template #cover>
    <!-- Cover Image -->
    @if (formCoverImage()) {
    <div class="banner">
        <img class="banner-image" [src]="formCoverImage()" alt="Cover Image">
    </div>
    }
</ng-template>

<ng-template #jobRoleHeader let-details>
    <div class="job-role-header-container">
        <div class="job-role-header-heading">
            {{details?.job_role_name}}
        </div>
        <div class="job-role-header-details">
            @if (details?.role_type_name) {
            <span class="neo-status-count no-margin-left">{{details?.role_type_name}}</span>
            }

            @if (details?.work_mode) {
            <span class="neo-status-count no-margin-left">{{details?.work_mode}}</span>
            }

            @if (details?.preferred_location?.length > 1) {
            <ng-template #multipleLocationTooltip>
                <ol style="list-style-position: inside;">
                    @for (locations of details?.preferred_location; track $index) {
                    <li>{{locations}}</li>
                    }
                </ol>
            </ng-template>
            <span class="neo-status-count no-margin-left" [pTooltip]="multipleLocationTooltip"
                tooltipPosition="bottom">{{details?.preferred_location?.length}} Locations</span>
            } @else if(details?.preferred_location?.length === 1) {
            <span class="neo-status-count no-margin-left">{{details?.preferred_location[0]}}</span>
            }
        </div>
    </div>
</ng-template>

@if (showCrispBtn && (!otpRequired() || otpVerified() || emailVerified())) {
<button class="crisp-fab"
        (click)="openCrispChat()"
        type="button"
        title="Chat with Support"
        aria-label="Chat with Support">
    <i class="pi pi-comment"></i>
</button>
}